export const FEATURES = {
  EVENT_BOOKING: "Event Booking",
  MEMBER_BOOKING: "Member Booking",
};
